import { atom } from 'jotai';

/**
 * Tracks whether the dialogue queue currently has an active dialogue to show.
 * When true, the popup queue suppresses itself to give dialogues priority.
 */
export const hasActiveDialogueAtom = atom(false);
